/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import $ from "jquery";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";

import LoginModal from "./LoginModal";
import RegistModal from "./RegistModal";
import PopupRegistModal from "./PopupRegistModal";
import PersonalRegistModal from "./PersonalRegistModal";
import ChangePWModal from "./ChangePWModal";
import FindPWModal from "./FindPWModal";
import FindIDModal from "./FindIDModal";
import GBTSLogoSvg from "../assets/GBTSLogoSvg";

import Oceanlook from "../lib/oceanlook";

import BuddibleSocket, { MsgIDList } from "../lib/BuddibleSocket";
import CodeList from "../lib/CodeList";

window.jQuery = $;
window.$ = $;
global.jQuery = $;

const socket = new BuddibleSocket();
const codeList = new CodeList();
const oceanlook = new Oceanlook();

const _mClassName = "CommonNav";
let loginInfo = null;

export default function CommonNav(props) {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  const [isOpenMobileNav, setIsOpenMobileNav] = useState(""); // "" or  "show"
  const [isShowScheduleSub, setIsShowScheduleSub] = useState("");
  const [isShowPostSub, setIsShowPostSub] = useState("");
  const [isLogin, setIsLogin] = useState(false);
  const [logoColor, setLogoColor] = useState("#f8f9fa");
  const [lang, setLang] = useState("ko");
  const { t, i18n } = useTranslation();

  const location = useLocation();

  useEffect(() => {
    askNotificationPermission();
    controlScrollNavClass();
    window.addEventListener("resize", handleResizeMobileNavState);
    window.addEventListener("scroll", controlScrollNavClass);

    const userData = socket.getLocalDataSet(MsgIDList.EVENT_LOGIN_AUTO_SUCCESS);
    if (userData) {
      if (userData.ret) {
        loginInfo = userData["returnData"][0];
        setIsLogin(true);
      }
    }

    socket.addLocalEventListener(
      MsgIDList.EVENT_LOGIN_AUTO_SUCCESS,
      _mClassName,
      (b, n) => {
        if (n.ret) {
          loginInfo = n["returnData"][0];
          setIsLogin(true);
        }
      }
    );

    return () => {
      window.removeEventListener("resize", handleResizeMobileNavState);
      window.removeEventListener("scroll", controlScrollNavClass);
      socket.removeLocalEventListener(
        MsgIDList.EVENT_LOGIN_AUTO_SUCCESS,
        _mClassName
      );
    };
  }, []);

  useEffect(() => {
    if (location.hash === "#regist" && !isLogin) {
      document.querySelector("#registModalBtn").click();
    }
  }, [isLogin]);

  useEffect(() => {
    const _body = $("body");
    if (isOpenMobileNav) {
      _body.css("height", "100vh");
      _body.css("overflow", "hidden");
    } else {
      _body.css("height", "100%");
      _body.css("overflow", "visible");
    }
  }, [isOpenMobileNav]);

  useEffect(() => {
    if (location.hash) {
      window.scrollTo({
        top: document.querySelector(location.hash)?.offsetTop,
      });
    }
  }, [location.hash]);

  function controlScrollNavClass() {
    $("#plain").removeClass("sticky");
    if (window.scrollY > 10) {
      $("#plain").removeClass("bg-transparent");
      $("#plain").addClass("bg-white shadow-sm");
      $(".change-color").removeClass("text-white border-white");
      $(".change-color").addClass("text-secondary border-secondary");
      setLogoColor("#38383a");
    } else {
      $("#plain").removeClass("bg-white shadow-sm");
      $("#plain").addClass("bg-transparent");
      $(".change-color").removeClass("text-secondary border-secondary");
      $(".change-color").addClass("text-white border-white");
      setLogoColor("#f8f9fa");
    }
  }

  function handleResizeMobileNavState() {
    if (window.innerWidth < 992) {
      setIsMobile(true);
    } else {
      const layerElement = document.getElementById("layer");

      layerElement.className = "layer";
      setIsOpenMobileNav("");
      setIsMobile(false);
    }
  }

  function toggleMobileNavOpen(e) {
    const layerElement = document.getElementById("layer");
    if (isOpenMobileNav) {
      layerElement.className = "layer";
      setIsOpenMobileNav("");
    } else {
      layerElement.className = "layer layer-is-visible";
      setIsOpenMobileNav("show");
    }
  }

  function toggleMobileNavSubMenu(e, classHandler) {
    if (!isMobile) return;
    e.preventDefault();
    classHandler((prevState) => {
      return prevState ? "" : " show_normal";
    });
  }

  async function handleLogout(e) {
    e.preventDefault();
    codeList.Modal.current.confirm(t("commonNav.msg.confirmLogout"), (ret) => {
      if (ret) {
        sessionStorage.removeItem("loginInfo");
        localStorage.removeItem("loginInfo");
        window.location.replace("/");
      }
    });
  }

  function askNotificationPermission() {
    // 권한을 실제로 요구하는 함수
    function handlePermission(permission) {
      // 사용자의 응답에 관계 없이 크롬이 정보를 저장할 수 있도록 함
      if (!("permission" in Notification)) {
        Notification.permission = permission;
      }
    }

    // 브라우저가 알림을 지원하는지 확인
    if (!("Notification" in window)) {
      console.log("이 브라우저는 알림을 지원하지 않습니다.");
    } else {
      if (checkNotificationPromise()) {
        Notification.requestPermission().then((permission) => {
          handlePermission(permission);
        });
      } else {
        Notification.requestPermission(function (permission) {
          handlePermission(permission);
        });
      }
    }
  }

  function checkNotificationPromise() {
    try {
      Notification.requestPermission().then();
    } catch (e) {
      return false;
    }

    return true;
  }

  return (
    <>
      <header id="plain" className="transition-1 bg-transparent z-index-99">
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <div className="container py-3 px-lg-0 px-xl-3 py-lg-0">
          <div className="row m-0 p-0 d-flex flex-row justify-content-between align-items-xl-center">
            <CommonNavLogo logoColor={logoColor} />
            <CommonNavMenuList
              isLogin={isLogin}
              isMobile={isMobile}
              isOpenMobileNav={isOpenMobileNav}
              isShowScheduleSub={isShowScheduleSub}
              setIsShowScheduleSub={setIsShowScheduleSub}
              isShowPostSub={isShowPostSub}
              setIsShowPostSub={setIsShowPostSub}
              toggleMobileNavOpen={toggleMobileNavOpen}
              toggleMobileNavSubMenu={toggleMobileNavSubMenu}
              handleLogout={handleLogout}
            />
            <CommonNavWebGNB
              isMobile={isMobile}
              isLogin={isLogin}
              lang={lang}
              handleLogout={handleLogout}
            />
          </div>
        </div>
      </header>
      <LoginModal
        setIsLogin={setIsLogin}
        toggleMobileNavOpen={toggleMobileNavOpen}
      />
      <RegistModal />
      <PopupRegistModal />
      <PersonalRegistModal />
      <ChangePWModal />
      <FindPWModal />
      <FindIDModal />
    </>
  );
}

const CommonNavLogo = ({ logoColor }) => {
  return (
    <div className="col-auto m-0 p-0 child-center">
      <div className="child-center justify-content-start">
        <Link to="/#mainTop">
          <div id="logo" className="m-0">
            <GBTSLogoSvg height="20px" color={logoColor} />
          </div>
        </Link>
      </div>
    </div>
  );
};
const CommonNavMenuList = (props) => {
  const {
    isLogin,
    isMobile,
    isOpenMobileNav,
    isShowScheduleSub,
    setIsShowScheduleSub,
    isShowPostSub,
    setIsShowPostSub,
    toggleMobileNavOpen,
    toggleMobileNavSubMenu,
    handleLogout,
  } = props;
  const { t } = useTranslation();
  return (
    <nav className="col m-0 p-0">
      <a
        className="cmn-toggle-switch cmn-toggle-switch__htx open_close mt-1"
        style={{ right: 0 }}
        onClick={(e) => {
          isMobile && toggleMobileNavOpen(e);
        }}
      >
        <span>Menu mobile</span>
      </a>

      <div className={`main-menu ${isOpenMobileNav}`}>
        <Link
          to="/"
          id="header_menu"
          onClick={(e) => {
            isMobile && toggleMobileNavOpen(e);
          }}
        >
          <GBTSLogoSvg height={"26px"} />
        </Link>
        <Link to="#" className="open_close" id="close_in">
          <i
            className="icon_set_1_icon-77"
            onClick={(e) => {
              isMobile && toggleMobileNavOpen(e);
            }}
          />
        </Link>

        <ul className="d-lg-flex flex-lg-row justify-content-lg-center">
          <li className="submenu px-0 text-lg-center">
            <Link
              to="/#mainService"
              id="show-submenu"
              className="show-submenu change-color text-white font-weight-normal"
              onClick={(e) => {
                toggleMobileNavSubMenu(e, setIsShowScheduleSub);
              }}
            >
              <p className="px-xl-2">
                {t("commonNav.schedule.title")}{" "}
                <i className="icon-down-open-mini mr-0" />
              </p>
            </Link>
            <ul className={isShowScheduleSub}>
              <li>
                <Link
                  to="/ScheduleLCL"
                  onClick={(e) => {
                    isMobile && toggleMobileNavOpen(e);
                  }}
                >
                  {t("commonNav.schedule.lcl")}
                </Link>
              </li>
              <li>
                <Link
                  to="/ScheduleFCL"
                  onClick={(e) => {
                    isMobile && toggleMobileNavOpen(e);
                  }}
                >
                  {t("commonNav.schedule.fcl")}
                </Link>
              </li>
              <li>
                <Link
                  to="/ScheduleAIR"
                  onClick={(e) => {
                    isMobile && toggleMobileNavOpen(e);
                  }}
                >
                  {t("commonNav.schedule.air")}
                </Link>
              </li>
            </ul>
          </li>

          <li className="submenu px-0 text-lg-center">
            <Link
              to="/#mainService"
              id="show-submenu"
              className="show-submenu change-color text-white font-weight-normal"
              onClick={(e) => {
                toggleMobileNavSubMenu(e, setIsShowScheduleSub);
              }}
            >
              <p className="px-xl-2">
                {t("commonNav.serviceInfo")}{" "}
                <i className="icon-down-open-mini mr-0" />
              </p>
            </Link>
            <ul className={isShowScheduleSub}>
              <li className="submenu px-0 px-lg-1">
                <Link
                  to="/INFO"
                  onClick={(e) => {
                    isMobile && toggleMobileNavOpen(e);
                  }}
                >
                  GBTS
                </Link>
              </li>
              <li className="submenu px-0 text-lg-center">
                <Link
                  to="/LogiTalkLanding"
                  onClick={(e) => {
                    isMobile && toggleMobileNavOpen(e);
                  }}
                >
                  LOGITALK
                </Link>
              </li>
              <li className="submenu px-0 text-lg-center">
                <Link
                  to="/LogiWorkLanding"
                  id="show-submenu"
                  className="show-submenu font-weight-normal"
                  onClick={(e) => {
                    isMobile && toggleMobileNavOpen(e);
                  }}
                >
                  LOGIWORK
                </Link>
              </li>
            </ul>
          </li>

          <li className="submenu px-0 text-lg-center">
            <Link
              to="/storeMall"
              className="change-color text-white px-0 font-weight-normal"
              onClick={(e) => {
                isMobile && toggleMobileNavOpen(e);
              }}
            >
              <p className="px-xl-2">{t("commonNav.store")}</p>
            </Link>
          </li>
          <li className="submenu px-0 text-lg-center">
            <a
              href="https://iamforwarder.gbts.co.kr/iamforwarder"
              target="_blank"
              className="change-color text-white px-0 font-weight-normal"
              onClick={(e) => {
                isMobile && toggleMobileNavOpen(e);
              }}
            >
              <p className="px-xl-2">{t("commonNav.quotationManagement")}</p>
            </a>
          </li>
          <li className="submenu px-0 text-lg-center">
            <a
              href="https://www.cardlogis.com/"
              target="_blank"
              className="change-color text-white px-0 font-weight-normal"
              onClick={(e) => {
                isMobile && toggleMobileNavOpen(e);
              }}
            >
              <p className="px-xl-2">{t("commonNav.logisticsPayment")}</p>
            </a>
          </li>
          <li className="submenu px-0 text-lg-center">
            <Link
              to="/PostMain"
              id="show-submenu"
              className="show-submenu change-color text-white font-weight-normal"
              onClick={(e) => {
                toggleMobileNavSubMenu(e, setIsShowPostSub);
              }}
            >
              <p className="px-xl-2">
                {t("commonNav.others.title")}{" "}
                <i className="icon-down-open-mini" />
              </p>
            </Link>
            <ul className={isShowPostSub}>
              <li>
                <Link
                  to="/PostList/notice"
                  onClick={(e) => {
                    isMobile && toggleMobileNavOpen(e);
                  }}
                >
                  {t("commonNav.others.notices")}
                </Link>
              </li>
              <li>
                <Link
                  to="/PostList/carrierNotice"
                  onClick={(e) => {
                    isMobile && toggleMobileNavOpen(e);
                  }}
                >
                  {t("commonNav.others.shippingAndAirlineNotices")}
                </Link>
              </li>
              <li>
                <Link
                  to="/AdvertiseVideoCenter"
                  onClick={(e) => {
                    isMobile && toggleMobileNavOpen(e);
                  }}
                >
                  {t("commonNav.others.mediaCenter")}
                </Link>
              </li>
              <li>
                <Link
                  to="/PostList/qna"
                  onClick={(e) => {
                    isMobile && toggleMobileNavOpen(e);
                  }}
                >
                  {t("commonNav.others.QAndABoard")}
                </Link>
              </li>
              <li>
                <Link
                  to="/PostList/promotion"
                  onClick={(e) => {
                    isMobile && toggleMobileNavOpen(e);
                  }}
                >
                  {t("commonNav.others.featuredCarriersAndPromotion")}
                </Link>
              </li>
            </ul>
          </li>
          {isOpenMobileNav !== "" ? (
            isLogin ? (
              <>
                <li>
                  <Link
                    to="/LogiTalk"
                    target="_blank"
                    className="search-overlay-menu-btn cart_bt cursor_pointer text-decoration-none"
                  >
                    {t("commonNav.logitalk")}
                    <i>
                      <img
                        className="rounded-lg border"
                        src="/img/use_img/play_store_512.png"
                        alt="로지톡"
                        style={{ width: "1.75rem", height: "1.75rem" }}
                      />
                    </i>
                  </Link>
                </li>
                <li>
                  <a
                    className="text-decoration-none change-color text-white"
                    href="/ERP"
                    style={{ lineHeight: 45 }}
                  >
                    <i className="icon-user" />
                    {t("commonNav.erp")}
                  </a>
                </li>
                <li>
                  <a
                    className="text-decoration-none change-color text-white"
                    href="/"
                    onClick={handleLogout}
                  >
                    <i className="icon-logout" />
                    {t("commonNav.logout")}
                  </a>
                </li>
              </>
            ) : (
              <>
                <li>
                  <a
                    className="text-decoration-none change-color text-white"
                    data-toggle="modal"
                    data-target="#loginModal"
                    href="#"
                  >
                    <i className="icon-login" />
                    {t("commonNav.login")}
                  </a>
                </li>

                <li>
                  <a
                    className="text-decoration-none change-color text-white"
                    id="registModalBtn"
                    data-toggle="modal"
                    data-target="#popupRegistModal"
                    href="#"
                  >
                    <i className="icon-user-add-1" /> {t("commonNav.join")}
                  </a>
                </li>
              </>
            )
          ) : (
            ""
          )}
        </ul>
      </div>
    </nav>
  );
};

const CommonNavWebGNB = (props) => {
  const { isMobile, isLogin, handleLogout } = props;
  const { t } = useTranslation();
  return (
    <div
      className={`col-auto m-0 p-0 child-center ${isMobile ? "d-none" : ""}`}
    >
      <ul className="d-flex flex-row align-items-center justify-content-end">
        {isLogin && (
          <>
            <li>
              <a
                href="/"
                onClick={handleLogout}
                className="transition-1 font-weight-bold gnb-item change-color text-white"
              >
                {t("commonNav.logout")}
              </a>
            </li>
            <li
              className="ml-1 pr-1 border-left border-white change-color"
              style={{ height: "0.75rem" }}
            />
            <li>
              <a
                href="/ERP"
                className="transition-1 font-weight-bold gnb-item change-color text-white"
              >
                {t("commonNav.erp")}
              </a>
            </li>
          </>
        )}
        {!isLogin && (
          <>
            <li>
              <a
                data-toggle="modal"
                data-target="#loginModal"
                href="#"
                className="transition-1 font-weight-bold gnb-item change-color text-white"
              >
                {t("commonNav.login")}
              </a>
            </li>

            <li
              className="ml-2 pr-2 border-left border-white change-color"
              style={{ height: "1rem" }}
            />
            <li>
              <a
                id="registModalBtn"
                data-toggle="modal"
                data-target="#popupRegistModal"
                href="#"
                className="transition-1 font-weight-bold gnb-item change-color text-white"
              >
                {t("commonNav.join")}
              </a>
            </li>
          </>
        )}

        <li className="ml-2 d-flex flex-row align-items-center">
          <a
            className="text-freiscop overflow-hidden d-inline-flex flex-row align-items-center cursor_pointer slide-width"
            style={{ height: "1.75rem" }}
            onClick={() => {
              if (loginInfo) {
                window.open("/LogiTalk");
                return;
              }
              codeList.Modal.current.alert(t("commonNav.msg.requiresLogin"));
            }}
          >
            <img
              className="rounded-lg border"
              src="/img/use_img/play_store_512.png"
              alt="로지톡"
              style={{ width: "1.75rem", height: "1.75rem" }}
            />

            {/*{unreadCount > 0 && <strong>{unreadCount}</strong>}*/}
            <span className="font-weight-900 slide-width-hidden">
              <p className="pl-1" style={{ width: "3rem" }}>
                {t("commonNav.logitalk")}
              </p>
            </span>
          </a>
        </li>
      </ul>
    </div>
  );
};
